/**
 * @ngdoc services
 * @memberof mercury.services
 * @name notifications
 */
angular.module('mercury.services.notifications')
.factory('notificationService', ["$q", "$resource", "userinfo", "settings", function($q, $resource, userinfo, settings) {
  var ServerNotices = $resource(settings.apiHost + '/r/CompanyNotifications');
  var showNotifications = true;

  /**
   * @memberof notifications
   */
  function GetNotifications() {
    if (userinfo.activeCompany()) {
      return ServerNotices.query().$promise;
    } else {
      return $q.when([]);
    }
  }

  function setShowNotifications(show) {
    showNotifications = show;
  }

  function getShowNotifications() {
    return showNotifications;
  }

  return {
    GetNotifications: GetNotifications,
    getShowNotifications: getShowNotifications,
    setShowNotifications: setShowNotifications
  };
}]);
